<div class="preview-shell">
  <div class="preview-header">
    <div>
      <p class="preview-kicker">PDF preview</p>
      <h2>{{ data.title }}</h2>
      <p class="preview-filename">{{ data.fileName }}</p>
    </div>

    <button class="close-button" type="button" aria-label="Close dialog" (click)="close()">×</button>
  </div>

  <div class="preview-body">
    <object class="preview-frame" [data]="safeUrl" type="application/pdf">
      <div class="preview-fallback">
        <p>This browser cannot show the PDF inside the popup.</p>
        <a [href]="data.url" target="_blank" rel="noopener">Open PDF</a>
      </div>
    </object>
  </div>
</div>